// faqData.ts
// Definição das interfaces para tipagem
export interface Question {
  id: string;
  question: string;
  answer: string;
  section?: string;
}

export interface FAQSection {
  title: string;
  icon: string;
  questions: Question[];
}

export interface FAQSections {
  [key: string]: FAQSection;
}

// Dados das FAQs
export const faqSections: FAQSections = {
    sobre: {
      title: "Sobre a Prime Cursos",
      icon: "🏢",
      questions: [
        {
          id: "o-que-e",
          question: "1. O que é a Prime Cursos?",
          answer: "A Prime Cursos é uma plataforma de ensino a distância (EAD) fundada em 2008, com sede em Blumenau/SC. Oferece mais de 350 cursos livres gratuitos em diversas áreas. O estudo, o material e as avaliações são 100% online e gratuitos. A empresa é associada à ABED (Associação Brasileira de Educação a Distância) e possui boa reputação no Reclame Aqui e Google Reviews."
        },
        {
          id: "pagar-cursos",
          question: "2. Preciso pagar algo para fazer os cursos? Há mensalidade?",
          answer: "Não. Todos os cursos, materiais e avaliações são 100% gratuitos. Não há cobrança de matrícula ou mensalidade. O único custo opcional é a emissão do certificado de conclusão."
        },
        {
          id: "prazo-conclusao",
          question: "3. Qual o prazo para começar e concluir os cursos?",
          answer: "Não há prazo mínimo ou máximo. Os cursos são permanentes e ficam disponíveis 24 horas por dia, 7 dias por semana. Os cursos da Prime Cursos são 100% flexíveis, o que significa que você pode iniciar e concluir quando quiser, além de estudar de qualquer lugar, a qualquer momento, no seu próprio ritmo. O acesso é liberado imediatamente após a matrícula."
        },
        {
          id: "como-funciona",
          question: "4. Como funciona o estudo? Os cursos têm videoaulas ou tutoria?",
          answer: "Os cursos são interativos, combinando textos, imagens e, em alguns casos, vídeos, focando em um aprendizado dinâmico. Alguns cursos oferecem materiais somente em texto, enquanto outros incluem vídeos como complemento. De forma geral, o conteúdo principal está disponível para leitura, permitindo que você estude no seu ritmo. O suporte ao aluno é focado na utilização do site e seus recursos; dúvidas sobre o conteúdo dos cursos devem ser sanadas pelo material disponível na plataforma."
        },
        {
          id: "estudar-qualquer-lugar",
          question: "5. Posso estudar de qualquer lugar?",
          answer: "Sim, basta ter acesso à internet em qualquer dispositivo (computador, tablet, celular)."
        },
        {
          id: "escolaridade-minima",
          question: "6. Existe escolaridade ou idade mínima para fazer os cursos?",
          answer: "Não há exigência de escolaridade ou idade mínima para participar. No entanto, para emissão de nota fiscal e certificado, é necessário informar CPF e RG."
        },
        {
          id: "varios-cursos",
          question: "7. Posso fazer mais de um curso ao mesmo tempo?",
          answer: "Sim, não há limite. Você pode se matricular e cursar quantos desejar simultaneamente."
        },
        {
          id: "fazer-cadastro",
          question: "8. Como faço meu cadastro?",
          answer: "Acesse o site www.primecursos.com.br e clique em \"Cadastrar\". Após preencher os dados, você já pode escolher e se matricular nos cursos."
        }
      ]
    },
    cursos: {
      title: "Cursos e Aprendizagem",
      icon: "📚",
      questions: [
        {
          id: "avaliacao-funcionamento",
          question: "9. Como funciona a avaliação? Qual a nota mínima? E se eu reprovar?",
          answer: "Ao final do estudo, você pode solicitar a avaliação de suficiência. A nota mínima para aprovação é 5,0 (50% de acerto). Caso reprove, pode refazer a avaliação gratuitamente quantas vezes precisar, até atingir a média. Uma vez aprovado, não é possível refazer a avaliação para melhorar a nota. A nota não consta no certificado, a menos que solicitado previamente."
        },
        {
          id: "gabarito",
          question: "10. Quando posso ver o gabarito da prova?",
          answer: "O gabarito fica disponível automaticamente na página do curso concluído, mas somente após a confirmação do pagamento do certificado. Não é possível liberá-lo antes."
        },
        {
          id: "refazer-curso",
          question: "11. Posso refazer um curso que já fui aprovado?",
          answer: "Não é possível refazer um curso no mesmo cadastro após a aprovação. Para refazê-lo (por exemplo, para obter um certificado com data atualizada), você precisa criar um novo cadastro no site usando um e-mail diferente."
        },
        {
          id: "imprimir-material",
          question: "12. Posso imprimir ou salvar o material do curso?",
          answer: "Sim. Cada lição possui um botão \"IMPRIMIR\" abaixo do título. Alternativamente, você pode copiar o conteúdo e colar em um editor de textos (como Word) para salvar ou imprimir."
        },
        {
          id: "curso-engano",
          question: "13. Assinei um curso por engano, posso excluí-lo?",
          answer: "Não, infelizmente não é possível excluir um curso após tê-lo assinado no site. Porém, você pode simplesmente ignorá-lo e focar nos demais cursos disponíveis. Lembre-se, todos os cursos são gratuitos e você pode se inscrever em quantos quiser!"
        },
        {
          id: "cursos-atualizados",
          question: "14. Os cursos são atualizados?",
          answer: "Sim, a Prime Cursos possui uma equipe dedicada a atualizar os cursos que necessitam de ajustes. Cursos que não precisam de atualização permanecem inalterados. Se encontrar material desatualizado, por favor, informe a equipe para revisão."
        },
        {
          id: "empresas-pj",
          question: "14.1. Empresas (PJ) podem utilizar a plataforma?",
          answer: "A plataforma atualmente atende exclusivamente pessoas físicas (PF). Para contratações empresariais (PJ), é necessário entrar em contato com nosso atendimento humano para orientações específicas sobre contratação para funcionários."
        }
      ]
    },
    certificados: {
      title: "Certificados",
      icon: "🏆",
      questions: [
        {
          id: "certificado-obrigatorio",
          question: "15. O certificado é obrigatório? Preciso pagar por ele?",
          answer: "Não, o certificado é totalmente opcional. Você só paga se desejar obter o comprovante após ser aprovado na avaliação."
        },
        {
          id: "certificado-nao-gratis",
          question: "16. Por que o certificado não é grátis como os cursos?",
          answer: "A taxa cobrada pelo certificado (opcional) cobre os custos de manutenção da plataforma, equipe de suporte, professores, produção de novos cursos, além dos custos de emissão, confecção e envio (no caso do impresso)."
        },
        {
          id: "valores-certificados",
          question: "17. Quais os valores e tipos de certificado?",
          answer: "Certificado Digital (PDF): R$ 49,90. Fica disponível para download e impressão na Área do Aluno imediatamente após a confirmação do pagamento.\n\nCertificado Impresso: R$ 59,90 + frete. Enviado pelos Correios, inclui papel especial, selo de autenticidade e conteúdo programático no verso.\n\nFrete (Certificado Impresso): R$ 10,30 para 1 certificado; R$ 11,15 para 2 a 5 certificados no mesmo pedido. Acima de 5, o valor é ajustado pelo peso. Você pode simular o frete no carrinho de compras."
        },
        {
          id: "solicitar-certificado",
          question: "18. Como solicitar o certificado?",
          answer: "Após ser aprovado na avaliação (nota >= 5,0), acesse sua \"Área de Aluno\", vá em \"Meus Certificados\", selecione o curso e clique em \"Emitir Certificado\". Escolha a versão (Digital ou Impressa), confirme seus dados e prossiga para o pagamento."
        },
        {
          id: "qualquer-momento",
          question: "19. Posso solicitar o certificado a qualquer momento?",
          answer: "Sim, não há prazo limite para solicitar o certificado após a conclusão do curso. Seus dados e notas ficam salvos no sistema."
        },
        {
          id: "emissao-padrao",
          question: "19.1. Como os certificados são emitidos por padrão?",
          answer: "Os certificados são emitidos mencionando apenas o mês e o ano da conclusão por padrão."
        },
        {
          id: "info-adicional",
          question: "19.2. Posso solicitar informações adicionais no certificado?",
          answer: "Sim, você pode solicitar:\n- Data de conclusão por extenso (exemplo: \"XX de Fevereiro de XXXX\").\n- Período completo do curso (exemplo: \"XX/XX/XXXX a XX/XX/XXXX\"), mostrando o dia em que o curso foi assinado e o dia da aprovação na avaliação.\n\nPara incluir o período completo, envie uma solicitação para contato@primecursos.com.br informando seu e-mail cadastrado e os cursos desejados."
        },
        {
          id: "conteudo-programatico",
          question: "20. O certificado contém o conteúdo programático?",
          answer: "Sim, tanto a versão impressa quanto a digital incluem o conteúdo programático do curso no verso ou em página adicional."
        },
        {
          id: "reconhecimento-mec",
          question: "21. O certificado é reconhecido pelo MEC?",
          answer: "Não. O MEC reconhece apenas cursos de graduação, pós-graduação e técnicos profissionalizantes. Os cursos da Prime Cursos são classificados como \"cursos livres\"."
        },
        {
          id: "para-que-serve",
          question: "22. Para que servem os certificados? São válidos para horas extracurriculares ou concursos?",
          answer: "Os certificados são válidos em todo o território nacional e podem ser usados para:\n- Atualizar o currículo e aumentar chances de emprego ou promoção.\n- Completar horas extracurriculares/complementares na faculdade.\n- Progressão funcional para servidores públicos.\n- Prova de títulos em concursos públicos (verificar edital).\n\nImportante: Como são cursos livres, sempre verifique antecipadamente com a instituição (faculdade, empresa, órgão de concurso) se o certificado será aceito para o fim desejado. Eles não substituem cursos técnicos ou de formação específica obrigatórios para certas profissões."
        },
        {
          id: "autenticidade",
          question: "23. Como confirmar a autenticidade do certificado?",
          answer: "Cada certificado possui um código de autenticidade (formato: 0000-0000). A validação pode ser feita no site: www.primecursos.com.br/confirma"
        }
      ]
    },
    pagamentos: {
      title: "Pagamentos",
      icon: "💳",
      questions: [
        {
          id: "formas-pagamento",
          question: "29. Quais são as formas de pagamento aceitas?",
          answer: "- Cartão de Crédito: parcelado em até 10x sem juros ou até 24x com juros via Mercado Pago.\n- PIX: confirmação imediata se via MercadoPago; não precisa enviar comprovante.\n- Boleto Bancário: confirmação em 1 a 3 dias úteis.\n- Depósito ou Transferência Bancária: confirmação em até 3 dias úteis após envio do comprovante para financeiro@primecursos.com.br.\n- PayPal: exclusivo para alunos no exterior, com cartão VISA ou Mastercard."
        },
        {
          id: "prazo-confirmacao",
          question: "30. Qual o prazo para confirmação do pagamento?",
          answer: "- PIX ou Cartão de Crédito: Confirmação imediata.\n- Boleto Bancário: 1 a 3 dias úteis.\n- Transferência/Depósito: Até 3 dias úteis após o envio do comprovante para o e-mail financeiro@primecursos.com.br."
        },
        {
          id: "pix-disponibilidade",
          question: "30.1. O certificado emitido após pagamento via PIX fica disponível imediatamente?",
          answer: "Sim, pagamentos via PIX têm confirmação quase instantânea. Dessa forma, o certificado já fica disponível no site e também é enviado por e-mail."
        },
        {
          id: "agilizar-boleto",
          question: "31. É possível agilizar a confirmação do pagamento por boleto enviando o comprovante?",
          answer: "Não. A confirmação do boleto depende exclusivamente da compensação bancária, que leva de 1 a 3 dias úteis. Enviar o comprovante não acelera o processo."
        },
        {
          id: "agendamento-boleto",
          question: "32. Enviei um comprovante de agendamento de boleto, por que meu pagamento não foi confirmado?",
          answer: "Um comprovante de agendamento apenas indica a intenção de pagar em data futura, não confirma o pagamento efetivo. É necessário enviar o comprovante de pagamento realizado. Se o agendamento for para após o vencimento, o boleto pode não ser compensado."
        },
        {
          id: "segunda-via",
          question: "33. Como gerar a segunda via do boleto?",
          answer: "Acesse a \"ÁREA PARA ALUNOS\", vá até a aba \"MEUS PEDIDOS\", localize o pedido e clique em \"Gerar Segunda Via do Boleto\"."
        },
        {
          id: "mp-cancelado",
          question: "34. Meu pagamento via Mercado Pago foi cancelado por falha na validação. O que fazer?",
          answer: "Isso pode ocorrer por dados desatualizados ou inconsistências na sua conta Mercado Pago. Verifique seus dados (telefone, endereço) no MP. Como a Prime Cursos não tem acesso à sua conta MP, tente usar outra forma de pagamento (boleto, PIX por outra chave, transferência) ou entre em contato diretamente com o suporte do Mercado Pago."
        }
      ]
    },
    tecnicas: {
      title: "Questões Técnicas",
      icon: "⚙️",
      questions: [
        {
          id: "acesso-conta",
          question: "41. Não consigo acessar minha conta, o que fazer?",
          answer: "Primeiro, tente limpar o cache e o histórico do seu navegador de internet ou tente acessar por um navegador diferente. Isso resolve muitos problemas de login causados por dados armazenados. Veja como limpar o cache pesquisando \"como limpar o cache no navegador [nome do seu navegador]\".\n\nSe o problema for a senha, redefina-a aqui: https://www.primecursos.com.br/senha/\n\nSe ainda assim não conseguir acessar, entre em contato com o suporte."
        },
        {
          id: "nota-nao-apareceu",
          question: "42. Terminei a prova, mas minha nota não apareceu. O que houve?",
          answer: "A nota é calculada imediatamente. Se não apareceu, pode ter ocorrido uma instabilidade no sistema que impediu a finalização correta da avaliação. Tente limpar o cache do navegador e refazer a prova. Você pode verificar a situação na \"ÁREA PARA ALUNOS\", aba \"MEUS CURSOS\"."
        },
        {
          id: "alterar-email",
          question: "43. Como altero meu e-mail de cadastro?",
          answer: "Entre em contato com o suporte informando o e-mail antigo (já cadastrado) e o e-mail novo que deseja cadastrar."
        },
        {
          id: "nome-errado",
          question: "44. Meu nome saiu errado no certificado. Como corrigir?",
          answer: "O certificado é emitido com os dados que você preencheu no cadastro do site, sendo sua responsabilidade mantê-los corretos. A Prime Cursos não altera dados manualmente.\n\nPara corrigir seu nome, siga o passo a passo neste link: https://www.primecursos.com.br/como-alterar-meu-nome-no-certificado/. Após a correção no site, saia e entre novamente na sua conta ou recarregue a página para visualizar o certificado atualizado."
        },
        {
          id: "emails-cobranca",
          question: "45. Estou recebendo muitos e-mails de cobrança, mesmo já tendo pago.",
          answer: "Esses e-mails são lembretes automáticos do sistema, enviados até que o pagamento seja efetivamente compensado e registrado. Se você já pagou (especialmente por boleto, que demora a compensar), pode desconsiderar esses e-mails automáticos."
        },
        {
          id: "login-transferivel",
          question: "45.1. O login e senha são transferíveis para outra pessoa?",
          answer: "Não. O login e senha escolhidos são pessoais e intransferíveis, garantindo acesso individual a todo o conteúdo gratuito disponível no site. Cada aluno deve ter seu próprio cadastro."
        }
      ]
    },
    confiabilidade: {
      title: "Confiabilidade e Segurança",
      icon: "🔒",
      questions: [
        {
          id: "empresa-confiavel",
          question: "46. A Prime Cursos é confiável? Se eu pagar, o certificado chega mesmo?",
          answer: "Sim, a Prime Cursos é uma empresa confiável. Fundada em 2008, é pioneira em EAD no Brasil, com milhões de alunos.\n\n- CNPJ: 09.408.027/0001-92 (pode ser consultado na Receita Federal).\n- Associação: Membro da ABED.\n- Reputação: Possui boa avaliação no Reclame Aqui e Google Reviews.\n\nA empresa confirma que os certificados pagos são enviados."
        },
        {
          id: "negativacao",
          question: "47. Se eu fizer um pedido de certificado e não pagar, meu nome vai para o Serasa?",
          answer: "Não. A Prime Cursos não trabalha com negativação de crédito ou cobrança judicial por pedidos não pagos. Se um pedido não for pago, ele é simplesmente cancelado automaticamente pelo sistema, sem gerar dívidas ou protestos."
        },
        {
          id: "dados-seguros",
          question: "48. Meus dados estão seguros? A Prime Cursos segue a LGPD?",
          answer: "Sim. A Prime Cursos afirma seguir a LGPD (Lei Geral de Proteção de Dados Pessoais) e o Marco Civil da Internet. O Ambiente Virtual de Aprendizagem (AVA) utiliza práticas de segurança e passa por auditorias. Seus dados não são compartilhados sem consentimento."
        },
        {
          id: "exclusao-dados",
          question: "49. Como solicitar a exclusão dos meus dados (LGPD)?",
          answer: "Envie um e-mail para lgpd@primecursos.com.br solicitando a exclusão.\n\nVocê precisará confirmar que está ciente de que a exclusão é permanente e todos os seus dados (cursos, certificados, histórico) serão eliminados sem possibilidade de recuperação. Informe o e-mail vinculado à conta. A solicitação é atendida em até 48 horas. Notas fiscais emitidas também podem ser canceladas."
        }
      ]
    },
    outras: {
      title: "Outras Dúvidas",
      icon: "❓",
      questions: [
        {
          id: "cursos-disponiveis",
          question: "50. Quais cursos estão disponíveis? Qual a carga horária?",
          answer: "A Prime Cursos oferece mais de 350 cursos em áreas como Administração, Comunicação, Contabilidade, Direito, Educação, Idiomas, Informática, Saúde, Segurança no Trabalho, entre outras. Você pode ver a lista completa de cursos e filtrar por área no site: https://www.primecursos.com.br/"
        },
        {
          id: "teologia-religiao",
          question: "51. O curso de Teologia é focado em alguma religião específica?",
          answer: "Não. O curso de Teologia Básico aborda os princípios gerais do saber teológico e a compreensão da fé e de Deus, sem se prender a uma religião específica."
        },
        {
          id: "supletivo",
          question: "52. A Prime Cursos oferece Supletivo (Ensino Fundamental ou Médio)?",
          answer: "Não. Os cursos são de nível livre (introdutório, qualificação, atualização), não sendo de nível fundamental, médio, técnico ou superior (graduação)."
        },
        {
          id: "carteira-estudante",
          question: "53. Posso obter carteira de estudante com os cursos da Prime Cursos?",
          answer: "Não. A Carteira de Identificação Estudantil geralmente não é concedida para alunos de cursos livres online de curta duração não reconhecidos pelo MEC."
        },
        {
          id: "corretor-creci",
          question: "54. O curso de Corretor de Imóveis Básico permite tirar o CRECI?",
          answer: "Não. Este é um curso livre introdutório, sem vínculo com o COFECI ou CRECI. Para atuar legalmente como Corretor de Imóveis e obter o registro no CRECI, é necessário fazer um curso de formação técnica específico reconhecido pelo conselho."
        },
        {
          id: "parceria",
          question: "55. Como posso propor uma parceria com a Prime Cursos?",
          answer: "Envie sua proposta de parceria para o e-mail: vendas@primecursos.com. O setor responsável analisará e retornará se houver interesse."
        },
        {
          id: "contato",
          question: "56. Como entrar em contato com a Prime Cursos?",
          answer: "- Telefone/WhatsApp: (11) 3958-4150\n- E-mail: contato@primecursos.com.br\n- Formulário de Contato: https://www.primecursos.com.br/contato/\n- Horário de atendimento: Segunda a sexta, das 08h30 às 12h e das 13h às 17h (horário de Brasília)."
        },
        {
          id: "vantagens",
          question: "57. Quais são as principais vantagens dos cursos 100% flexíveis da Prime Cursos?",
          answer: "Com a flexibilidade total, você escolhe quando começar e quando terminar cada curso, sem prazos rígidos. Além disso, pode acessar o conteúdo de onde estiver, usando qualquer dispositivo com internet, estudando nos momentos mais adequados para sua rotina. Essa liberdade permite conciliar estudos com trabalho, família e outras atividades, garantindo uma experiência de aprendizado mais confortável e eficiente."
        }
      ]
    }
  };

// Exemplo de um helper para filtrar perguntas pelo termo
export function filterQuestions(term: string): Question[] {
  const lowercaseTerm = term.toLowerCase();
  const filtered: Question[] = [];
  
  Object.keys(faqSections).forEach(sectionKey => {
    faqSections[sectionKey].questions.forEach(q => {
      if (q.question.toLowerCase().includes(lowercaseTerm) || 
          q.answer.toLowerCase().includes(lowercaseTerm)) {
        filtered.push({
          ...q,
          section: sectionKey
        });
      }
    });
  });
  
  return filtered;
}

